import { render, staticRenderFns } from "./BizCus.vue?vue&type=template&id=7f8ce3c7&scoped=true&"
import script from "./BizCus.vue?vue&type=script&lang=js&"
export * from "./BizCus.vue?vue&type=script&lang=js&"
import style0 from "./BizCus.vue?vue&type=style&index=0&id=7f8ce3c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8ce3c7",
  null
  
)

export default component.exports